export default __webpack_public_path__ + "static/media/compraNoPermitida.3e574887.svg";